// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3-1tP","productName":"Table_productName__2xHbS"};